import { getOpenCityList as cityList, checkPoiInfo as checkPOi, checkBizoppNameChange as checkBizoopName, getLaunchCityList as lcityList, getCommonConfig } from '@/api'
// import Vue from 'vue'
// import { Dialog } from '@didi/rich-ui'
import { i18n } from '@/common/utils/i18n'
// Vue.use(Dialog)
export function getOpenCityList () {
  return cityList().then(res => {
    return Object.keys(res || {}).map(key => {
      const { cityId, cityName } = res[key]
      return { text: cityName, value: cityId }
    })
  })
}

export function getLaunchCityList () {
  return lcityList().then(res => {
    return Object.keys(res || {}).map(key => {
      const { cityId, cityName } = res[key]
      return { text: cityName, value: cityId }
    })
  })
}

const confirmDialog = ({title = '', content = ''}, context) => {
  return new Promise((resolve, reject) => {
    // const $dialog = Vue.prototype.$createDialog({
    //   type: 'confirm',
    //   title,
    //   content,
    //   zIndex: 901,
    //   icon: 'richic-alert'
    // })
    // $dialog.show()
    // $dialog.$on('confirm', () => {
    //   // 销毁实例
    //   resolve()
    //   $dialog.remove()
    // }).$on('cancel', () => {
    //   reject()
    //   $dialog.remove()
    //   console.log('cancel')
    // })
    context.$createDialog({
      type: 'confirm',
      icon: 'richic-alert',
      zIndex: 901,
      title,
      content,
      confirmBtn: {
        text: i18n.gettext('确定')
      },
      cancelBtn: {
        text: i18n.gettext('取消')
      },
      onConfirm: () => {
        resolve()
      },
      onCancel: () => {
        reject()
      }
    }).show()
  })
}

// 10000  poi校验通过
// 10001
// 地址坐标不在商圈范围，确定提交？
// 10002
// 地址坐标不在商圈范围，确定保存？
export function checkPoiInfo (params, context) {
  return checkPOi(params).then(({ code, msg = '' }) => {
    if (code === 10000) {
      return {}
    } else {
      // 提示是否强制提交
      return confirmDialog({title: msg}, context).then(() => {
        return {
          forceSubmit: 1 // 强制提交参数
        }
      }).catch((e) => {
        console.log(e)
        // 不强制提交则中断提交流程
        throw new Error(msg + 'checkPoiInfo 取消提交')
      })
    }
  })
}
// 10000 正常
// 10003 检测到修改异常，商机名称差异过大，是否继续提交？
export function checkBizoppNameChange (params, context) {
  return checkBizoopName(params).then(({ code, msg = '' }) => {
    if (code === 10000) {
      return {}
    } else {
      // 提示是否强制提交
      return confirmDialog({title: msg}, context).then(() => {
        return {
          forceSubmit: 1 // 强制提交参数
        }
      }).catch(() => {
        // 不强制提交则中断提交流程
        throw new Error(msg + 'checkBizoppNameChange 取消提交')
      })
    }
  })
}

export function getFormatCommonConfig (params) {
  return getCommonConfig(params).then(res => {
    return Array.isArray(res) && res.map(item => {
      return {
        text: item.value,
        value: item.key
      }
    })
  })
}
